import { Box, Button } from "@mui/material";
import { FormSubmitButton } from "@ngt/forms";
import NextButton from "./NextButton";

interface IFormButtonProps {
    activeStep: number;
    handleNext: () => void;
    setCompleted: React.Dispatch<React.SetStateAction<Record<number, boolean>>>;
    handleBack: () => void;
}

const FormButtons: React.FunctionComponent<IFormButtonProps> = ({
    activeStep,
    handleNext,
    setCompleted,
    handleBack
}) => {
    if (activeStep === 0) {
        return <NextButton 
            onClick={handleNext} 
            index={activeStep}
            setComplete={setCompleted}
        />;
    }
    else if (activeStep === 3) {
        return <>
            <Box>
                <FormSubmitButton variant="contained"
                    sx={{
                        float: "right",
                        marginTop:"20px",
                    }}>
                    Submit
                </FormSubmitButton>
                <Button variant="contained" 
                    onClick={handleBack}
                    sx={{
                        marginTop:"20px",
                        marginRight:"20px",
                        float: 'right'
                    }}>
                    Back
                </Button>
            </Box>
        </>;
    }
    else {
        return <Box>
        <NextButton 
            onClick={handleNext} 
            index={activeStep}
            setComplete={setCompleted}
        />
        <Button variant="contained" 
                onClick={handleBack}
                sx={{
                    marginTop:"20px",
                    marginRight:"20px",
                    float: 'right'
                }}>
                Back
        </Button>
    </Box>;
    }
};

export default FormButtons;